import { Box, Button, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MainCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  display: 'flex',
  flexDirection: 'column',
}));

export const SectionCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? '#0b0f14' : COLORS.WHITE,
  borderRadius: 8,
  // border: 'solid 1px #2d343e',
  border: '1px solid',
  borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  marginBottom: 15,
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '12px 0',
  },
}));

//HEADER
export const Header = styled(Box)(({ theme }) => ({
  // borderRight: '1px solid #2d343e',
  borderRight: '1px solid',
  borderRightColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
  display: 'flex',
  flex: 1,
  paddingRight: 15,
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
    alignItems: 'unset',
    paddingBottom: 10,
  },
}));

export const HLeft = styled(Box)(({ theme }) => ({
  minWidth: 200,
  display: 'flex',
  [theme.breakpoints.down(960)]: {
    alignItems: 'center',
    height: 'fit-content',
  },
  '& svg': {
    '&:not(.gradientIcon) path': {
      fill: COLORS.PRIMARY,
    },
  },
}));

export const HeaderTitle = styled(Box)(({ theme }) => ({
  alignSelf: 'center',
  marginLeft: 15,
  [theme.breakpoints.down(960)]: {
    marginLeft: 10,
  },
}));

export const Name = styled(Box)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  letterSpacing: 0.48,
  [theme.breakpoints.down(960)]: {
    fontSize: 15,
  },
}));
export const Count = styled(Box)(({ theme }) => ({
  fontSize: 15,
  letterSpacing: 0.4,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  [theme.breakpoints.down(960)]: {
    fontSize: 12,
  },
}));

export const HRight = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const CompletionCont = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  alignSelf: 'center',
  display: 'flex',
  flex: 1,
  maxWidth: 300,
  [theme.breakpoints.down(960)]: {
    marginTop: 10,
    maxWidth: 'unset',
    width: '100%',
  },
}));

export const Percent = styled(Box)(() => ({
  fontSize: 12,
  fontWeight: 500,
  marginRight: 20,
}));

export const AddButton = styled(Button)(({ theme }) => ({
  width: 134,
  height: 36,
  bordeRadius: 4,
  border: 'solid 1px #3e8bff',
  backgroundColor: 'transparent',
  borderImageSlice: 1,
  marginLeft: 20,
  fontSize: 13,
  fontWeight: 500,
  fontFamily: 'Inter',
  [theme.breakpoints.down(960)]: {
    marginLeft: 'auto',
    width: 'unset',
  },
}));

export const Content = styled(Box)(({ theme }) => ({
  padding: 10,
  display: 'flex',
  overflow: 'auto',
  flexWrap: 'wrap',
  maxHeight: 500,
  width: '100%',
  [theme.breakpoints.down(960)]: {
    maxHeight: 'unset',
    flexDirection: 'column',
  },
}));

export const BinHeader = styled(Typography)(() => ({
  fontSize: 24,
  fontWeight: 600,
}));

export const SelectedContent = styled(Box)(() => ({
  color: '#3a81eb',
  fontSize: 16,
  fontWeight: 500,
}));

export const Fetching = styled(Box)(() => ({
  // flex: 1,
  width: '100%',
  height: 100,
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
}));

export const Hidden = styled(Typography)(() => ({
  margin: '10px 5px',
  borderBottom: '1px rgb(103, 111, 122) dashed',
  width: '100%',
}));

export const HiddenCont = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '99%',
}));
